import React, { useRef, useEffect, useState } from 'react';
import VanillaTilt from 'vanilla-tilt';
import styles from './Profile.module.scss';
import { useAuth } from '../../context/AuthContext';
import CountUp from '../UI/CountUp'; // Подключили анимацию чисел
import ProfileSettings from '../ProfileSettings/ProfileSettings';

function formatRuDate(value) {
  if (!value) return '—';

  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';

  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(d);
}

const Profile = () => {
  const { user, logout } = useAuth();

  const profileRef = useRef(null);

  const [avgIncome, setAvgIncome] = useState(0);
  const [monthsLabel, setMonthsLabel] = useState('Средний доход');

  const name = user?.name || 'Пользователь';
  const email = user?.email || '';
  const avatar = name.charAt(0).toUpperCase();
  const registeredAt = formatRuDate(user?.created_at);

  useEffect(() => {
    const isDesktop = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    if (profileRef.current && isDesktop) {
      VanillaTilt.init(profileRef.current, {
        max: 10,
        speed: 1000,
        perspective: 1000,
        glare: true,
        'max-glare': 0.1,
        scale: 1,
        reset: true,
      });
    }

    return () => {
      if (profileRef.current && profileRef.current.vanillaTilt) {
        profileRef.current.vanillaTilt.destroy();
      }
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await fetch('/api/stats/months?count=6', {
          credentials: 'include',
        });

        if (!res.ok) throw new Error('Не удалось загрузить статистику');

        const data = await res.json();
        const points = Array.isArray(data?.points) ? data.points : [];

        const totalIncome = points.reduce(
          (sum, p) => sum + (Number(p?.income) || 0),
          0
        );

        let monthsActive = 1;

        if (user?.created_at) {
          const created = new Date(user.created_at);
          const now = new Date();

          monthsActive =
            (now.getFullYear() - created.getFullYear()) * 12 +
            (now.getMonth() - created.getMonth()) +
            1;

          monthsActive = Math.min(monthsActive, 6);
        }

        const average = monthsActive ? totalIncome / monthsActive : 0;

        const label =
          monthsActive === 1
            ? 'Доход за этот месяц'
            : `Средний доход за ${monthsActive} мес.`;

        if (!cancelled) {
          setAvgIncome(average);
          setMonthsLabel(label);
        }
      } catch {
        if (!cancelled) setAvgIncome(0);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className={styles.profile} ref={profileRef}>
      <div className={styles.profile__head}>
        <div className={styles.profile__avatar}>{avatar}</div>
      </div>

      <h4 className={styles.profile__name}>{name}</h4>
      <h4 className={styles.profile__email}>{email}</h4>
      <ProfileSettings 
          currentUser={user} 
          trigger="Изменить"
          triggerClassName={styles.profile__settingsBtn} 
        />

      <div className={styles.profile__items}>
        <div className={`${styles.profile__goals} ${styles.profile__item}`}>
          <h4 className={styles.profile__value}>{registeredAt}</h4>
          <span className={styles.profile__subtitle}>Дата регистрации</span>
        </div>

        <div className={`${styles.profile__goals} ${styles.profile__item}`}>
          <h4 className={styles.profile__value}>
            <CountUp 
              from={0} 
              to={Math.round(avgIncome)} 
              separator=' ' 
              duration={0.5} 
            />
            <span className={styles.currency}> ₽</span>
          </h4>
          <span className={styles.profile__subtitle}>{monthsLabel}</span>
        </div>
      </div>

      <button type='button' className={styles.profile__logout} onClick={logout}>
        Выйти
      </button>
    </div>
  );
};

export default Profile;